import axios from 'axios';

const api = axios.create({
  baseURL: 'https://constructiontechpro.com/api/api',
  withCredentials: true, // Necessary for Laravel Sanctum
});

// Fetch CSRF token before making a request
api.interceptors.request.use(async (config) => {
    const response = await axios.get('https://constructiontechpro.com/api/sanctum/csrf-cookie', {
    withCredentials: true
});

  // Check if the response status is 401
  if (response.status === 401) {
    window.location.href = '/login';
  }  
  // Manually attach CSRF token from cookies
  const xsrfToken = getCookie('XSRF-TOKEN');
  if (xsrfToken) {
    config.headers['X-XSRF-TOKEN'] = xsrfToken;
  }else{
   
  }
  return config;
});

// Function to read cookies
function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=');
    if (cookieName === name) return decodeURIComponent(cookieValue);
  }
  return null;
}

export default api;
